const pagesLaborCoreSettingsEn = {
  applicantContacts: {
    title: "Applicant & Contact Information",
    description:
      "You can pre-configure information to be used for electronic applications.",
    addButton: "Add Applicant & Contact",
    default: "Default",
    actions: {
      viewDetails: "View Details",
      edit: "Edit",
    },
    createSuccess: "Profile created successfully",
    updateSuccess: "Profile updated successfully",
    dialog: {
      addTitle: "Add Applicant & Contact",
      editTitle: "Edit Applicant & Contact",
      profileName: "Profile Name",
      profileNamePlaceholder: "Enter profile name",
      setAsDefault: "Set as default",
      setAsDefaultDescription:
        "This profile will be selected by default when creating new applications",
      cancel: "Cancel",
      create: "Create",
      creating: "Creating...",
    },
  },
  profileDetail: {
    breadcrumbs: {
      laborCore: "Labor Core",
      settings: "Settings",
    },
    navigation: {
      applicantInformation: "Applicant Information",
      contactInformation: "Contact Information",
      certificate: "Electronic Certificate",
      eGovAccount: "e-Gov Account Information",
    },
    error: {
      loadFailed: "Failed to load data",
      unknownError: "An unknown error occurred",
      noData: "Data not found",
    },
    toast: {
      applicantUpdated: "Applicant information updated successfully",
      contactUpdated: "Contact information updated successfully",
    },
  },
  certificate: {
    title: "Electronic Certificate",
    noCertificate: "No certificate uploaded",
    fileName: "File Name",
    subject: "Subject",
    issuer: "Issuer",
    validTo: "Valid Until",
    expiringSoon: "Expiring soon",
    upload: "Upload",
    update: "Update",
    dialog: {
      title: "Upload Electronic Certificate",
      pin: "PIN (Password)",
      pinPlaceholder: "Enter certificate PIN",
      supportedFormats: "Supported formats: .p12, .pfx",
      invalidFileType: "Unsupported file format (only .p12, .pfx)",
      fileSelectError: "Failed to select file",
      cancel: "Cancel",
      uploadButton: "Upload",
      uploading: "Uploading...",
    },
    uploadSuccess: "Certificate uploaded successfully",
  },
  eGovAccount: {
    title: "e-Gov Account Information",
    notConnected: "e-Gov account is not connected",
    email: "Email Address",
    providerType: "Provider",
    accountType: "Account Type",
    connect: "Connect",
    reconnect: "Reconnect",
  },
  validation: {
    required: "{{field}} is required",
  },
  callback: {
    sessionNotFound:
      "Session information not found. Please start the connection again.",
    invalidAuthInfo:
      "Invalid authentication information. Please start the connection again.",
    connectionComplete: "Successfully connected with e-Gov",
    connectionFailed: "e-Gov authentication failed",
  },
};

export default pagesLaborCoreSettingsEn;
